<template>
  <div class="view--coupon">
    <loader v-if="loader"></loader>

    <header class="header">
      <div class="containter">
        <div class="row justify-content-center">
          <div class="col col-md-6 col-lg-4">
            <nav class="nav">
              <router-link :to="{ name: 'Coupons' }" tag="div" class="back">
                <i class="material-icons icon">chevron_left</i>
              </router-link>
              <h1 class="title">{{ $t('coupons.title') }}</h1>
              <button
                class="send btn"
                v-on:click="toggleGift"
                v-if="coupon.gift && !coupon.used && !coupon.expired"
              >
                <i class="material-icons">redeem</i>
                {{ $t('coupons.send') }}
              </button>
              <div class="placeholder" v-else></div>
            </nav>
          </div>
        </div>
      </div>
    </header>
    <main v-cloak>
      <div class="containter">
        <div class="row no-gutters justify-content-center">
          <div class="col col-md-6 col-lg-4">
            <div
              class="coupon"
              :class="{
              used: coupon.used,
              expired: coupon.expired,
            }"
            >
              <img class="image" :src="coupon.image" />
            </div>
            <div class="tool">
              <div
                class="prev"
                :class="{ disable: coupon.prev === null }"
                v-if="isMulti"
                v-on:click="goPrev()"
              >
                <i class="material-icons">chevron_left</i>
              </div>
              <div class="meta">
                <div class="name">
                  {{ coupon.name }}<template v-if="isMulti">・{{ coupon.current }}/{{ coupon.total }}</template>
                  <span v-on:click="toggleMulti()" class="multi" v-else>
                    <i class="material-icons">dynamic_feed</i>
                  </span>
                </div>
                <div
                  v-if="coupon.used"
                  class="used"
                >{{ $t('coupons.usedOn') }} {{ coupon.usedTimestamp | moment('l LT') }}</div>
                <div :class="$root.$i18n.locale === 'zh-Hant' ? 'expired': 'expiredEn'" v-else>
                  <template
                    v-if="coupon.receive"
                  >{{ coupon.valid | moment('l LT') }}～{{ coupon.expire | moment('l LT') }}</template>
                </div>
              </div>
              <div
                class="next"
                :class="{ disable: coupon.next === null }"
                v-if="isMulti"
                v-on:click="goNext()"
              >
                <i class="material-icons">chevron_right</i>
              </div>
            </div>

            <div class="sub-title">{{ $t('coupons.instruction') }}</div>
            <div class="desc" v-html="coupon.desc" v-linkified></div>
            <div class="sub-title">{{ $t('coupons.how') }}</div>
            <div class="comment" v-html="coupon.comment" v-linkified></div>
            <div class="info">
              <div
                class="timestamp"
                v-if="coupon.receive"
              >{{ $t('coupons.receivedOn') }} {{ coupon.receive | moment('l') }}</div>
              <div class="serial">{{ $t('coupons.serialNumber') }} <span class="monospace">{{ coupon.serial }}</span></div>
            </div>
          </div>
        </div>
      </div>
      <i18n-picker></i18n-picker>
    </main>
    <footer class="footer" v-if="coupon.redeemable && !coupon.used">
      <div class="containter">
        <div class="row justify-content-center narrow-gutters">
          <div class="col col-md-3 col-lg-2" v-if="coupon.redeem !== 3 && coupon.redeem !== 4 && coupon.total > 1 && coupon.multiRedeem">
            <button class="btn" v-on:click="redeemMulti">{{ $t('coupons.multiRedeem') }}</button>
          </div>
          <div class="col" :class="coupon.redeem !== 3 && coupon.redeem !== 4 && coupon.total > 1 && coupon.multiRedeem ? 'col-md-3 col-lg-2' : 'col-md-6 col-lg-4'">
            <button class="btn" v-on:click="redeem">{{ $t('coupons.redeem') }}</button>
          </div>
        </div>
      </div>
    </footer>
    <div class="coupon-share" :class="{ 'active': couponShare }"  v-body-scroll-lock="couponShare">
      <div class="containter">
        <div class="row justify-content-center">
          <div class="col col-12 col-md-6 col-lg-4">
            <div class="coupon-share__container">
              <ul class="nav nav-pills nav-justified" id="pills-tab" role="tablist">
                <li class="nav-item">
                  <a
                    class="nav-link"
                    :class="{ 'active' : couponShareMode === 'mobile' }"
                    v-on:click.prevent="couponShareMode = 'mobile'"
                  >
                    {{ $t('coupons.viaMobileNumber') }}
                    <div class="caption">{{ $t('coupons.viaMobileNumberDesc') }}</div>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    :class="{ 'active' : couponShareMode === 'sns' }"
                    v-on:click.prevent="couponShareMode = 'sns'"
                  >
                    {{ $t('coupons.viaSNS') }}
                    <div class="caption">{{ $t('coupons.viaSNSDesc') }}</div>
                  </a>
                </li>
              </ul>
              <div class="tab-content">
                <div
                  class="tab-pane fade"
                  :class="{ 'active' : couponShareMode === 'mobile', 'show' : couponShareMode === 'mobile' }"
                >
                  <form class="form" action="#" v-on:submit.prevent="shareViaMobile()">
                    <div class="row no-gutters">
                      <div class="col-5 cell-country__container">
                        <country-select
                          class="cell-country"
                          v-on:select-country="selectedCountry($event)"
                          :defaultCountry="'TW'"
                        ></country-select>
                      </div>
                      <div class="col-7">
                        <input
                          type="tel"
                          class="cell"
                          :placeholder="$t('entry.common:mobileNumber')"
                          v-model="couponShareCell"
                        />
                      </div>
                    </div>
                    <div class="row narrow-gutters">
                      <div class="col-auto">
                        <button
                          class="btn btn-lg btn-block btn-secondary"
                          v-on:click.prevent="cancelShare"
                        >{{ $t('common.cancel') }}</button>
                      </div>
                      <div class="col">
                        <button
                          class="btn btn-lg btn-block"
                          :class="{ 'btn-loading': couponShareLoading }"
                          type="submit"
                        >
                          {{ $t('common.submit') }}
                          <div class="btn-loader"><span></span><span></span><span></span></div>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <div
                  class="tab-pane fade"
                  :class="{ 'active' : couponShareMode === 'sns', 'show' : couponShareMode === 'sns' }"
                >
                  <textarea
                    id="coupon-share-text"
                    class="coupon-share-text"
                    v-model="couponShareText"
                    readonly
                  ></textarea>
                  <div class="coupon-share-tools">
                    <a
                      class="coupon-share-btn"
                      target="_blank"
                      :href="'https://line.me/R/msg/text/?' + encodeURI(couponShareText)"
                      v-on:click="ShareViaLine"
                    >
                      <div class="icon">
                        <svg class="line" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 32.4">
                          <title>Line</title>
                          <g id="FULL_COLOR_ICON" data-name="FULL COLOR ICON">
                            <g id="TYPE_A" data-name="TYPE A">
                              <path
                                d="M44,25.6C44,18,36.37,11.8,27,11.8S10,18,10,25.6c0,6.82,6.05,12.53,14.22,13.61.55.12,1.3.36,1.49.84a3.3,3.3,0,0,1,.06,1.53s-.2,1.2-.24,1.46c-.08.43-.34,1.68,1.47.92s9.79-5.77,13.36-9.87h0A12.31,12.31,0,0,0,44,25.6"
                                transform="translate(-10 -11.8)"
                                style="fill:#00b900"
                              />
                              <path
                                d="M23.55,21.92h-1.2a.33.33,0,0,0-.33.33v7.41a.33.33,0,0,0,.33.33h1.2a.33.33,0,0,0,.33-.33V22.25a.33.33,0,0,0-.33-.33"
                                transform="translate(-10 -11.8)"
                                style="fill:#fff"
                              />
                              <path
                                d="M31.75,21.92H30.56a.33.33,0,0,0-.33.33v4.4l-3.39-4.58,0,0h0l0,0h0l0,0h0l0,0H25.37a.33.33,0,0,0-.33.33v7.41a.33.33,0,0,0,.33.33h1.19a.33.33,0,0,0,.33-.33v-4.4l3.4,4.59a.3.3,0,0,0,.08.08h0l0,0h1.35a.33.33,0,0,0,.33-.33V22.25a.33.33,0,0,0-.33-.33"
                                transform="translate(-10 -11.8)"
                                style="fill:#fff"
                              />
                              <path
                                d="M20.67,28.14H17.43V22.25a.33.33,0,0,0-.33-.33H15.91a.33.33,0,0,0-.33.33v7.41h0a.32.32,0,0,0,.09.23h0a.32.32,0,0,0,.23.09h4.76a.33.33,0,0,0,.33-.33V28.47a.33.33,0,0,0-.33-.33"
                                transform="translate(-10 -11.8)"
                                style="fill:#fff"
                              />
                              <path
                                d="M38.34,23.78a.33.33,0,0,0,.33-.33v-1.2a.33.33,0,0,0-.33-.33H33.57a.34.34,0,0,0-.23.1h0a.33.33,0,0,0-.1.23h0v7.41h0a.33.33,0,0,0,.1.23h0a.36.36,0,0,0,.22.09h4.77a.33.33,0,0,0,.33-.33V28.47a.33.33,0,0,0-.33-.33H35.1V26.88h3.24a.33.33,0,0,0,.33-.33V25.36a.33.33,0,0,0-.33-.33H35.1V23.78Z"
                                transform="translate(-10 -11.8)"
                                style="fill:#fff"
                              />
                            </g>
                          </g>
                        </svg>
                      </div>
                      <div class="label">{{ $t('coupons.line') }}</div>
                    </a>
                    <a
                      class="coupon-share-btn"
                      target="_blank"
                      :href="'fb-messenger://share/?link=' + encodeURIComponent(couponShareURL) + '&app_id=1568893940066963'"
                      v-on:click="ShareViaMessenger"
                    >
                      <div class="icon">
                        <svg
                          class="messenger"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          viewBox="0 0 994 994"
                          style="enable-background:new 0 0 994 994;"
                          xml:space="preserve"
                        >
                          <svg:style>
                            .st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#gradient);}
                            .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
                          </svg:style>
                          <g id="logo">
                            <radialGradient id="gradient" cx="1005.4268" cy="1218.4703" r="1.3538" gradientTransform="matrix(800 0 0 -799.9999 -804150.125 975764.9375)" gradientUnits="userSpaceOnUse">
                              <stop  offset="0" style="stop-color:#0099FF"/>
                              <stop  offset="0.6098" style="stop-color:#A033FF"/>
                              <stop  offset="0.9348" style="stop-color:#FF5280"/>
                              <stop  offset="1" style="stop-color:#FF7061"/>
                            </radialGradient>
                            <path class="st0" d="M497,0C217,0,0,205.1,0,482.1C0,627,59.4,752.2,156.1,838.7c8.1,7.3,13,17.4,13.4,28.3l2.7,88.4
                              c0.9,28.2,30,46.5,55.8,35.2l98.6-43.5c8.4-3.7,17.7-4.4,26.5-1.9c45.3,12.5,93.6,19.1,143.9,19.1c280,0,497-205.1,497-482.1
                              S777,0,497,0z"/>
                            <path class="st1" d="M198.6,623.1l146-231.6c23.2-36.8,73-46,107.8-19.9l116.1,87.1c10.7,8,25.3,7.9,35.9-0.1l156.8-119
                              c20.9-15.9,48.3,9.2,34.2,31.4l-146,231.6c-23.2,36.8-73,46-107.8,19.9l-116.1-87.1c-10.7-8-25.3-7.9-35.9,0.1l-156.8,119
                              C211.9,670.4,184.5,645.3,198.6,623.1z"/>
                          </g>
                        </svg>
                      </div>
                      <div class="label">{{ $t('coupons.messenger') }}</div>
                    </a>
                    <a
                      class="coupon-share-btn coupon-share-btn-copy"
                      data-clipboard-target="#coupon-share-text"
                      :aria-label="couponShareURL"
                      v-on:click="ShareViaCopy"
                    >
                      <div class="icon">
                        <i class="material-icons">file_copy</i>
                      </div>
                      <div class="label">{{ $t('coupons.copy') }}</div>
                    </a>
                    <a
                      class="coupon-share-btn"
                      :href="'sms:&body=' + encodeURI(couponShareText)"
                      v-if="client.os.includes('iOS')"
                      v-on:click="ShareViaSMS"
                    >
                      <div class="icon">
                        <i class="material-icons">sms</i>
                      </div>
                      <div class="label">{{ $t('coupons.sms') }}</div>
                    </a>
                    <a
                      class="coupon-share-btn"
                      :href="'sms:?body=' + encodeURI(couponShareText)"
                      v-if="client.os.includes('Android')"
                      v-on:click="ShareViaSMS"
                    >
                      <div class="icon">
                        <i class="material-icons">sms</i>
                      </div>
                      <div class="label">{{ $t('coupons.sms') }}</div>
                    </a>
                    <a class="coupon-share-btn" v-on:click="ShareViaWebShareAPI" v-if="webShareAPI">
                      <div class="icon">
                        <i class="material-icons">more_horiz</i>
                      </div>
                      <div class="label">{{ $t('coupons.other') }}</div>
                    </a>
                    <a
                      class="coupon-share-btn"
                      :href="'mailto:?&body=' + encodeURI(couponShareText)"
                      v-on:click="ShareViaEmail"
                      v-else
                    >
                      <div class="icon">
                        <i class="material-icons">mail</i>
                      </div>
                      <div class="label">E-mail</div>
                    </a>
                  </div>
                  <div class="row narrow-gutters">
                    <div class="col">
                      <button
                        class="btn btn-lg btn-block"
                        v-on:click.prevent="cancelShare"
                      >{{ $t('common.back') }}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="coupon-share-overlay" v-if="couponShare"></div>
    <div class="background">
      <div class="image" :style="'background-image: url(' + brand.image + ')'" v-if="brand.image"></div>
      <div class="image" :style="'background-image: url(' + coupon.brandImage + ')'" v-else></div>
      <div class="overlay"></div>
    </div>
    <barcode
      :visable="barcode"
      :value="coupon.barcode.value"
      :format="coupon.barcode.format"
      :title="$t('barcode.redeemCouponViaBarcode')"
      :name="coupon.name"
      :qrcode="true"
      :cell="coupon.userCell"
      v-on:toggleBarcode="toggleBarcode"
      :barcodeTime="coupon.barcode.time"
    ></barcode>
    <ultrasound
      v-if="coupon.ultrasound"
      :visable="ultrasound"
      :ultrasound-playing="ultrasoundPlaying"
      v-on:toggleUltrasound="toggleUltrasound"
    ></ultrasound>

    <div class="qrcode-reader" v-if="showQrcodeReader">
      <svg class="qrcode-box" width="674px" height="674px" viewBox="0 0 674 674" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>Shape</title>
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
              <path d="M7,181.344194 C7,120.720919 13.3121416,98.7374551 25.1650239,76.5744922 C37.0179062,54.4115292 54.4115292,37.0179062 76.5744922,25.1650239 C98.7374551,13.3121416 120.720919,7 181.344194,7 M492.655806,7 C553.279081,7 575.262545,13.3121416 597.425508,25.1650239 C619.588471,37.0179062 636.982094,54.4115292 648.834976,76.5744922 C660.687858,98.7374551 667,120.720919 667,181.344194 M667,492.655806 C667,553.279081 660.687858,575.262545 648.834976,597.425508 C636.982094,619.588471 619.588471,636.982094 597.425508,648.834976 C575.262545,660.687858 553.279081,667 492.655806,667 M181.344194,667 C120.720919,667 98.7374551,660.687858 76.5744922,648.834976 C54.4115292,636.982094 37.0179062,619.588471 25.1650239,597.425508 C13.3121416,575.262545 7,553.279081 7,492.655806" id="Shape" stroke="#FFFFFF" stroke-width="14"></path>
          </g>
      </svg>
      <button class="qrcode-reader-close" v-on:click="showQrcodeReader = false">{{ $t('common.close') }}</button>
      <qrcode-stream v-on:decode="redeemViaQrcode" v-on:init="qrcodeReaderInit" />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { Howl } from 'howler';
import swal from 'sweetalert2';
import AwesomePhonenumber from 'awesome-phonenumber';
import ClipboardJS from 'clipboard';
import linkify from 'vue-linkify';
import { QrcodeStream } from 'vue-qrcode-reader';

import Mixin from '@/mixins';
import Axios from '@/helpers/axios';

import Loader from '@/components/Loader.vue';
import Barcode from '@/components/Barcode.vue';
import Ultrasound from '@/components/Ultrasound.vue';
import CountrySelect from '@/components/Entry/Country-Select.vue';
import I18nPicker from '@/components/I18nPicker.vue';

export default {
  name: 'Coupon',
  mixins: [Mixin],
  data() {
    return {
      barcode: false,
      ultrasound: false,
      ultrasoundPlaying: false,
      now: new Date(),

      couponShare: false,
      couponShareMode: 'mobile',
      couponShareCell: '',
      couponShareCountry: 'TW',
      couponShareText: '',
      couponShareURL: '',
      couponShareLoading: false,

      qrcodeRedeemAmount: 0,

      webShareAPI: navigator.share,

      showQrcodeReader: false,
    };
  },
  computed: {
    ...mapState(['loader', 'brand', 'coupon', 'client']),
    ultrasoundInstance() {
      if (this.coupon.ultrasound) {
        return new Howl({ src: this.coupon.ultrasound, loop: true });
      }
      return null;
    },
    couponShareCellInstance() {
      return new AwesomePhonenumber(
        this.couponShareCell,
        this.couponShareCountry,
      );
    },
    couponShareCellIsValid() {
      return (
        this.couponShareCellInstance.isValid() &&
          this.couponShareCellInstance.isMobile()
      );
    },
    isMulti() {
      return 'isMulti' in this.$route.query;
    },
  },
  methods: {
    ...mapMutations(['emptyCoupon']),
    ...mapActions(['getCoupon', 'useCoupon']),
    toggleBarcode() {
      this.barcode = !this.barcode;
    },
    toggleUltrasound() {
      this.ultrasoundInstance.once('play', () => {
        this.ultrasoundPlaying = true;

        this.$gtm.trackEvent({
          event: '使用禮物券音波感應',
          label: `${this.$root.$store.state.brand.name} - ${this.coupon.name}`,
        });
      });

      this.ultrasoundInstance.once('stop', () => {
        this.ultrasoundPlaying = false;
      });

      if (!this.ultrasound) {
        this.ultrasoundInstance.play();
      } else {
        this.ultrasoundInstance.stop();
      }

      this.ultrasound = !this.ultrasound;
    },
    toggleMulti() {
      this.emptyCoupon();

      this.getCoupon(this.$route.params.token);

      this.$router.replace({ query: { isMulti: null } });

      this.$gtm.trackEvent({
        event: '檢視多張禮物券',
        label: `${this.$root.$store.state.brand.name} - ${this.coupon.name}`,
      });
    },
    goPrev() {
      this.getCoupon(this.coupon.prev);

      this.$router.push({
        name: 'Coupon',
        params: { token: this.coupon.prev },
        query: { isMulti: null },
      });
    },
    goNext() {
      this.getCoupon(this.coupon.next);

      this.$router.push({
        name: 'Coupon',
        params: { token: this.coupon.next },
        query: { isMulti: null },
      });
    },
    redeemMulti() {
      swal.fire({
        text: this.$i18n.t('coupons.amount'),
        input: 'text',
        inputPlaceholder: this.$i18n.t('coupons.amountPlaceholder'),
        inputAttributes: {
          pattern: '[0-9]*',
        },
        confirmButtonText: this.$i18n.t('common.next'),
        showCancelButton: true,
        cancelButtonText: this.$i18n.t('common.cancel'),
        reverseButtons: true,
      }).then((redeemAmount) => {
        const amount = redeemAmount.value === '' ? 1 : redeemAmount.value;
        if (Number.isInteger(Number(amount)) && Number(amount) > 0) this.redeem(Number(amount));
      });
    },
    redeem(amount = 1) {
      this.redeemAmount = amount;
      switch (this.coupon.redeem) {
        // 條碼券
        case 3:
          this.toggleBarcode();
          return;

          // 音波感應
        case 4:
          this.toggleUltrasound();
          return;

        default:
          break;
      }

      swal.fire({
        text: amount > 1 ? this.$i18n.t('coupons.confirm2', { amount, coupon: this.coupon.name }) : this.$i18n.t('coupons.confirm', { coupon: this.coupon.name }),
        confirmButtonText: this.$i18n.t('common.next'),
        showCancelButton: true,
        cancelButtonText: this.$i18n.t('common.cancel'),
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          switch (this.coupon.redeem) {
            // 一般券
            case 1:
              this.useCoupon({
                id: this.coupon.id,
                name: this.coupon.name,
                amount,
              });
              break;

            // 店家核銷碼
            case 2:
              swal.fire({
                text: this.$i18n.t('coupons.storePIN', { coupon: this.coupon.name }),
                confirmButtonText: this.$i18n.t('common.next'),
                showCancelButton: true,
                cancelButtonText: this.$i18n.t('common.cancel'),
                showDenyButton: true,
                denyButtonText: this.$i18n.t('common.scan'),
                reverseButtons: true,
                input: 'password',
                inputAttributes: {
                  autocomplete: 'off',
                  autocapitalize: 'off',
                  autocorrect: 'off',
                  spellcheck: 'false',
                  id: 'redeem-code',
                },
              }).then((redeemCode) => {
                if (redeemCode.isDenied) {
                  this.qrcodeRedeemAmount = amount;
                  this.showQrcodeReader = true;
                }

                if (!redeemCode.value) {
                  return false;
                }

                this.useCoupon({
                  id: this.coupon.id,
                  name: this.coupon.name,
                  redeem: redeemCode.value,
                  amount,
                });

                return true;
              });
              break;

            default:
              break;
          }
        }
      });
    },
    toggleGift() {
      swal.fire({
        text: this.$i18n.t('coupons.sendDesc'),
        confirmButtonText: this.$i18n.t('common.next'),
        showCancelButton: true,
        cancelButtonText: this.$i18n.t('common.cancel'),
        reverseButtons: true,
      }).then((send) => {
        if (send.value) {
          this.couponShare = true;

          const data = {
            ...this.$route.query,
            lang: this.$i18n.locale,
            platform: this.client.phoneType,
            dtk: this.client.dtk,
            cid: this.coupon.id,
          };

          Axios({
            method: 'post',
            url: '/Gift/GetGiftCouponInfo',
            data,
          }).then((response) => {
            if (response.data.code === 500) {
              this.couponShareText = response.data.data.gift.sms;
              this.couponShareURL = response.data.data.gift.url;
            }
          });
        }
      });
    },
    selectedCountry(value) {
      this.couponShareCountry = value;
    },
    shareViaMobile() {
      if (!this.couponShareCellIsValid) {
        swal.fire({
          text: this.$i18n.t('common.mobileNumberIncorrect'),
          confirmButtonText: this.$i18n.t('common.ok'),
        });

        return false;
      }

      swal.fire({
        text: this.$i18n.t('coupons.mobileShareConfirm', {
          coupon: this.coupon.name,
          mobile: this.couponShareCellInstance
            .getNumber('international')
            .replace(/ /g, '-'),
        }),
        confirmButtonText: this.$i18n.t('common.next'),
        showCancelButton: true,
        cancelButtonText: this.$i18n.t('common.cancel'),
        reverseButtons: true,
      }).then((mobile) => {
        if (mobile.value) {
          this.couponShareLoading = true;

          const data = {
            ...this.$route.query,
            lang: this.$i18n.locale,
            platform: this.client.phoneType,
            dtk: this.client.dtk,
            cid: this.coupon.id,
            cell: this.couponShareCellInstance.getNumber('significant'),
            country_code: AwesomePhonenumber.getCountryCodeForRegionCode(this.couponShareCellInstance.getRegionCode()),
          };

          Axios({
            method: 'post',
            url: '/Gift/GiveGiftCoupon',
            data,
          }).then((response) => {
            this.couponShareLoading = false;

            if (response.data.code === 500) {
              this.$gtm.trackEvent({
                event: '轉送禮物券 - 手機',
                label: `${this.$root.$store.state.brand.name} - ${this.coupon.name}`,
              });

              swal.fire({
                text: response.data.data.msg,
                confirmButtonText: this.$i18n.t('common.ok'),
              }).then(() => {
                this.$router.push({ name: 'Coupons' });
              });
            } else {
              swal.fire({
                text: response.data.msg,
                confirmButtonText: this.$i18n.t('common.back'),
              }).then(() => {
                this.couponShareCell = '';
              });
            }
          });
        }
      });

      return true;
    },
    cancelShare() {
      this.couponShareCell = '';
      this.couponShare = false;
    },
    ShareViaLine() {
      this.$gtm.trackEvent({
        event: '轉送禮物券 - Line',
        label: `${this.$root.$store.state.brand.name} - ${this.coupon.name}`,
      });
    },
    ShareViaMessenger() {
      this.$gtm.trackEvent({
        event: '轉送禮物券 - Messenger',
        label: `${this.$root.$store.state.brand.name} - ${this.coupon.name}`,
      });
    },
    ShareViaSMS() {
      this.$gtm.trackEvent({
        event: '轉送禮物券 - SMS',
        label: `${this.$root.$store.state.brand.name} - ${this.coupon.name}`,
      });
    },
    ShareViaEmail() {
      this.$gtm.trackEvent({
        event: '轉送禮物券 - Email',
        label: `${this.$root.$store.state.brand.name} - ${this.coupon.name}`,
      });
    },
    ShareViaCopy() {
      this.$gtm.trackEvent({
        event: '轉送禮物券 - 拷貝網址',
        label: `${this.$root.$store.state.brand.name} - ${this.coupon.name}`,
      });

      const clipboard = new ClipboardJS('.coupon-share-btn-copy', {
        text: () => this.couponShareText,
      });

      clipboard.on('success', () => {
        this.$root.$message.success(this.$i18n.t('coupons.shareTextCopied'));
      });
    },
    ShareViaWebShareAPI() {
      navigator
        .share({
          text: this.couponShareText.replace(` ${this.couponShareURL}`, ''),
          url: this.couponShareURL,
        })
        .then(() => {
          this.$gtm.trackEvent({
            event: '轉送禮物券 - 原生 Share API',
            label: `${this.$root.$store.state.brand.name} - ${this.coupon.name}`,
          });
        });
    },
    async qrcodeReaderInit(promise) {
      try {
        await promise;
      } catch (error) {
        let errorMsg;

        if (error.name === 'NotAllowedError') {
          errorMsg = this.$i18n.t('common.notAllowedCameraError');
        } else if (error.name === 'NotFoundError') {
          errorMsg = this.$i18n.t('common.notFoundCameraError');
        } else if (error.name === 'NotSupportedError') {
          errorMsg = this.$i18n.t('common.notSupportedNetworkError');
        } else if (error.name === 'NotReadableError') {
          errorMsg = this.$i18n.t('common.notReadableCameraError');
        } else if (error.name === 'StreamApiNotSupportedError') {
          errorMsg = this.$i18n.t('common.streamApiNotSupportedError');
        } else if (error.name === 'InsecureContextError') {
          errorMsg = this.$i18n.t('common.notSupportedNetworkError');
        } else {
          errorMsg = this.$i18n.t('common.unableAccessCameraError');
        }

        this.showQrcodeReader = false;

        let errorText = '';
        if (this.$i18n.locale === 'zh-Hant') {
          errorText = `${errorMsg}，${this.$i18n.t('common.unableScanError')}`;
        } else if (this.$i18n.locale === 'en' || this.$i18n.locale === 'vi' || this.$i18n.locale === 'th') {
          errorText = `${errorMsg} ${this.$i18n.t('common.unableScanError')}`;
        } else {
          errorText = errorMsg;
        }


        swal.fire({
          text: errorText,
        });
      }
    },
    redeemViaQrcode(result) {
      this.useCoupon({
        id: this.coupon.id,
        name: this.coupon.name,
        redeem: result,
        amount: this.qrcodeRedeemAmount,
      });

      this.showQrcodeReader = false;
    },
  },
  beforeMount() {
    this.emptyCoupon();

    this.getCoupon(this.$route.params.token);
  },
  components: {
    Loader,
    I18nPicker,
    Barcode,
    Ultrasound,
    CountrySelect,
    QrcodeStream,
  },
  directives: {
    linkified: linkify,
  },
};
</script>

<style lang="sass" scoped>
$cb: cubic-bezier(.4, 0, .2, 1)

.view--coupon
  width: 100%
  height: 100%
  position: relative

  color: white

.background
  position: fixed
  width: 100%
  width: 100vw
  height: 100%
  height: 100vh
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: -1

  .overlay,
  .image
    position: absolute
    top: -10px
    right: -10px
    bottom: -10px
    left: -10px

    background-color: rgba(0, 0, 0, .45)

    background-size: cover
    background-position: center

  .overlay
    -webkit-backdrop-filter: saturate(150%)

  .image
    filter: blur(10px)

.header
  position: fixed
  top: 0
  right: 0
  left: 0
  padding: 12px
  z-index: 1020

  background-color: rgba(0, 0, 0, .25)

  color: white

  @supports (-webkit-backdrop-filter: blur(15px))
    box-shadow: 0 2px 5px rgba(0, 0, 0, .25)

    -webkit-backdrop-filter: blur(15px)
    background-color: rgba(0, 0, 0, .1)

  .nav
    display: flex

  .back
    height: 24px
    float: left

    .icon
      width: 36px
      height: 36px

      font-size: 2.25rem
      line-height: 1

  .title
    flex-grow: 1
    margin: 3px 0

    text-shadow: 0 1px 2px rgba(0, 0, 0, .5)
    font-size: 1.2081rem
    font-weight: bold
    text-align: center
    line-height: 28px

  .placeholder
    width: 36px

  .btn
    padding: 0
    height: 34px
    background: transparent

    color: rgba(255, 255, 255, .75)

    vertical-align: middle
    line-height: 34px

    outline: 0

    &:active
      color: rgba(255, 255, 255, .25)

  .material-icons
    margin-right: 4px
    vertical-align: middle

main
  padding: 60px 0 80px

  .coupon
    position: relative
    margin: 20px auto
    max-width: 90%
    height: auto

    text-align: center

    &.used,
    &.expired,
      &::after
        position: absolute
        top: 0
        right: 0
        bottom: 0
        left: 0
        z-index: 3

        background-size: 50%
        background-repeat: no-repeat
        background-position: center

        content: ''

      .image
        opacity: .5

    &.used
      &::after
        background-image: url(/assets/img/vip/coupon-used-en.png)
      html[lang='zh-Hant'] &::after
        background-image: url('/assets/img/vip/coupon-used.png');

    &.expired
      &::after
        background-image: url(/assets/img/vip/coupon-expired-en.png)
      html[lang='zh-Hant'] &::after
        background-image: url('/assets/img/vip/coupon-expired.png');

    .image
      width: 100%
      height: auto

  .name
    margin-bottom: 5ox

    font-size: 1.125em
    font-weight: bold
    text-align: center

    .multi
      display: inline-block
      margin-left: 4px

    .material-icons
      color: rgba(255, 255, 255, .5)

      cursor: pointer
      font-size: 1rem

      transform: translateY(2px)

  .tool
    padding: 0 24px
    display: flex
    align-items: center

  .prev,
  .next
    width: 36px
    height: 36px
    padding: 6px

    border-radius: 100%

    background-color: rgba(0, 0, 0, .4)

    cursor: pointer

    &.disable
      opacity: .25

      pointer-events: none
      cursor: not-allowed

  .meta
    margin: 0 8px
    flex-grow: 1

  .used,
  .expire
    font-size: 0.875rem
    text-align: center

    color: rgba(255, 255, 255, .5)

  .sub-title
    padding: 0 24px
    margin: 20px 0 10px

    font-weight: bold
    font-size: 0.875rem
    letter-spacing: 2px
    color: rgba(255, 255, 255, .75)
    text-transform: uppercase

  .desc,
  .comment
    margin: 8px 0 24px
    padding: 0 16px

    font-size: 0.875rem
    line-height: 1.6
    white-space: pre-wrap

    ::v-deep .linkified
      color: white
      text-decoration: underline

  .comment
    margin-bottom: 48px

  .info
    font-size: 0.75rem
    color: rgba(255, 255, 255, .5)
    text-align: center

  .timestamp,
  .serial
    display: inline-block

  .timestamp
    margin-right: .5em

  .serial
    margin-left: .5em

.footer
  position: fixed
  right: 0
  bottom: 0
  left: 0
  padding: 12px
  z-index: 1020

  text-align: center

  .btn
    padding: 10px
    display: block
    width: 100%

    border-radius: 99px

    background-color: #ffea00

    color: #333
    font-weight: bold
    font-size: 1.125em

    &:active
      opacity: .5

      transform: scale(.95)

.coupon-share
  position: fixed
  top: 50%
  left: 50%
  width: 100%
  z-index: 1050
  opacity: 0

  transform: translate(-50%, -50%) scale(.75)
  transition: transform .25s $cb

  pointer-events: none

  &-overlay
    position: fixed
    right: 0
    bottom: 0
    left: 0
    top: 0
    z-index: 1040

    background-image: linear-gradient(0deg, rgba(44, 43, 43, 0.665) 0%, rgba(33, 32, 32, 0.665) 100%)

  &.active
    opacity: 1

    transform: translate(-50%, -50%)
    pointer-events: auto

  &__container
    overflow: hidden
    width: 100%

    border-radius: 16px

    background-color: #282828

    color: white

  .nav-pills
    padding: 8px 8px 0

  .nav-link
    margin: 0 8px
    border-radius: 0
    position: relative

    font-weight: bold

    opacity: 0.5
    transition: box-shadow .25s ease, opacity .25s ease

    &::after
      content: ''
      position: absolute
      width: 100%
      height: 4px
      left: 0
      bottom: 0
      right: 0

      border-radius: 4px 4px 0 0

      background-color: transparent

      transition: background-color .25s $cb

    .caption
      display: block

      font-size: 0.75rem
      font-weight: normal
      color: rgba(255, 255, 255, .5)

    &.active
      box-shadow: inset 0 -2px 0 #ffea00
      opacity: 1

      background-color: transparent

      &::after
        background-color: #ffea00

  .tab-content
    padding: 24px 16px 16px

  &-text
    width: 100%
    padding: 16px

    border: none
    border-radius: 16px

    background-color: #333

    color: white

    &:focus
      outline: 0

  .form
    input[type=text],
    input[type=number],
    input[type=tel],
    input[type=password]
      width: 100%

      padding: 10px 15px

      border: none
      border-radius: 23px

      background-color: #eee

      font-weight: 700
      color: #333

      &:focus
        outline: none

    .readonly
      pointer-events: none

    .cell-country
      width: 100%
      padding: 10px 15px
      overflow: hidden

      border: none
      border-radius: 23px

      background-color: #ffea00
      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAAwCAYAAACooNxlAAAABGdBTUEAALGPC/xhBQAAAYxJREFUaAXt1T9ugzAUBnAMQ5Zmh1vwZ2qToVvVC+Qulao26aWabjkBp4gEe3bo+9JYslCRYgPCSJ8lBwh5j+cfthMEbBSgAAUoQAEKUIACFKAABShAAQpQgAIUcBHIsuxd+qNLrBlTFMVW+pv53ZznkcvDZQBfSqm99F0cx6e6rs+OebZt235LntckSVRVVSeXPGPGWIPIrDjIAD5uRaxcUTAzbhgPyCV5nn1ACW11pfC2E7MOw/DHZvmkaboxMTr5Zr20niGY1niTeKNG5XfPFGAI4FHirzND5xCgQ1mWe30919EaBIW6ogAjiiLsGWtzwL5goCYnEATaomgMCfUWA+NyBkHwvSiC8SQz4yghXmNgTAofQ1ue5/gL/uzkuTRN8yLLQS0FA/WPAoJEfSi4J837mfFX5sAlo5Pg2Ld85NbK/J1PG6hZlz4ftIfoJPrYg6JvB75joNBRQZCwD2UJGJOA/IeyFAzUPmnDRos+6UOYnAIUoAAFKEABClCAAhSgAAUoQAEKUGCQwC/1HLKALR1EkwAAAABJRU5ErkJggg==')
      background-size: 24px
      background-repeat: no-repeat
      background-position: right center

      font-weight: 700
      color: #333

      -webkit-padding-end: 24px
      appearance: none
      text-overflow: ellipsis
      white-space: nowrap

      &__container
        height: 44px

        border-radius: 23px 0 0 23px

        background-color: #333

      &::after
        content: ''

      &:focus
        outline: none

    .cell[type=tel]
      border-radius: 0 23px 23px 0

      background-color: #333

      color: white

  .btn
    position: relative
    margin-top: 24px
    padding: 8px 15px

    border-color: transparent
    border-radius: 99px

    background-color: #FFEA00

    font-size: 1.125em
    font-weight: 700
    color: #333

    outline: none
    appearance: none

    &:hover,
    &:active
      opacity: .5

      border-color: transparent

      background-color: #FFEA00

      color: #333

      outline: none

    &-secondary
      opacity: .5

    &.btn-loading
      pointer-events: none

      .btn-loader
        display: block

    .btn-loader
      position: absolute
      top: 0
      right: 0
      bottom: 0
      left: 0
      border-radius: 99px
      display: none

      background-color: inherit

      &.inverse
        span
          background-color: white

      span
        display: inline-block
        width: 10px
        height: 10px
        border-radius: 100%
        background-color: #575757
        margin: 18px 5px
        opacity: 0

        &:nth-child(1)
          animation: opacitychange .5s ease-in-out infinite

        &:nth-child(2)
          animation: opacitychange .5s ease-in-out .166666667s infinite

        &:nth-child(3)
          animation: opacitychange .5s ease-in-out .333333334s infinite

        @keyframes opacitychange
          0%, 100%
            opacity: 0

          60%
            opacity: 1

  &-tools
    margin: 10px -15px 0

    white-space: nowrap
    overflow-y: auto
    -webkit-overflow-scrolling: touch

    text-align: center

    .coupon-share-btn
      margin: 0 20px 0 0

      display: inline-block
      text-align: center

      color: inherit
      text-decoration: none
      vertical-align: middle

      &:first-child
        margin-left: 20px

      &:hover
        color: currentcolor

    .icon
      display: inline-block
      width: 54px
      height: 54px
      overflow: hidden

      border-radius: 50%

      background-color: #333

      .line,
      .messenger
        margin-top: 14px
        height: 26px
        width: auto

    .material-icons
      width: 54px
      height: 54px

      line-height: 54px
      color: white

    .label
      margin-top: 4px

      font-size: 0.75rem
      color: rgba(255, 255, 255, .5)

.qrcode-reader
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 1090
  overflow: hidden

  background: black

  .qrcode-box
    position: fixed
    top: 50%
    right: 0
    bottom: 0
    left: 50%
    width: 50vw
    max-width: 400px
    z-index: 2

    transform: translate(-50%, -50%)

    animation: scale-up-center .75s cubic-bezier(0.390, 0.575, 0.565, 1.000) infinite alternate both;

  .qrcode-reader-close
    position: fixed
    top: auto
    right: auto
    bottom: 5%
    left: 50%
    z-index: 2
    padding: 8px 16px

    border: 0
    border-radius: 10px

    background-color: rgba(0, 0, 0, .25)

    font-weight: bold
    color: white
    font-size: 0.75rem
    text-align: center

    cursor: pointer
    transform: translateX(-50%)

  .qrcode-stream-wrapper
    position: fixed
    top: 0
    right: 0
    bottom: 0
    left: 0

@keyframes scale-up-center
  0%
    transform: translate(-50%, -50%) scale(1)

  100%
    transform: translate(-50%, -50%) scale(1.15)
</style>
